/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_BadgeInputs */

const et_pricing_badge = /** @type {(inputs: Pricing_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketid`)
};

const en_pricing_badge = /** @type {(inputs: Pricing_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans`)
};

/**
* | output |
* | --- |
* | "Plans" |
*
* @param {Pricing_BadgeInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const pricing_badge = /** @type {((inputs?: Pricing_BadgeInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_BadgeInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_pricing_badge(inputs)
	return en_pricing_badge(inputs)
});